/* La paleta de formato de FiboSheets: fondos pastel (leen bien en los dos
 * temas) y colores de texto. "" es «sin color».
 *
 * Vive acá, y no en la pantalla, porque la usan dos: la barra de herramientas
 * de `routes/MiEspacio` (los botoncitos de colores) y la importación de Excel
 * (`shared/planillaEstilosExcel`), que lleva cada color de un Excel al de esta
 * paleta más parecido. Si se agrega un color, la importación lo empieza a usar
 * sola.
 */

export const FONDOS = ["", "#fff3b0", "#c8e6c9", "#bbdefb", "#f8bbd0", "#ffe0b2", "#e0e0e0"];
export const TEXTOS = ["", "#c0392b", "#1e7e34", "#1565c0", "#6a1b9a", "#555555"];
